const l10n: FooterL10n = {
  linkList: {
    "companyLink": "O nas",
    "termsOfService": "Warunki użytkowania",
    "privacyPolicy": "Polityka prywatności",
    "guaranteeOfRights": "Prawa podmiotu danych",
    "customerSupport": "WSPARCIE",
    "cookiePolicy": "Polityka plików cookie",
    "declarationOfSafety": "Deklaracja ochrony i bezpieczeństwa",
    "youthProtectionPolicy": "Polityka o ochronie młodzieży",
    "communityPolicy": "Polityka społeczności",
    "probability": "prawdopodobieństwo",
    "operationPolicy": "Polityka operacyjna",
    "doNotSell": "Proszę nie sprzedawać moich informacji osobistych",
    "gameGrade": "Ocena",
    "communityPolicyView": "커뮤니티정책",
    "servicePolicy": "서비스정책",
    "termsOfUse": "Warunki użytkowania",
    "operationPolicyNCJ": "운영방침",
    "reportRightsInfringement": "권리침해신고",
    "ncPrivacyCenter": "NC Privacy Center",
    "commercialTransactions": "특정상거래법에 의거한 표기",
    "settlementFund": "자금결제법에 따른 표시",
    "serviceTerm": "서비스 이용약관",
    "legalDocumentation": "Dokumentacja prawna",
    "googleAPIDisclosure": "Ujawnianie informacji Google API",
    "report": "신고하기",
    "serviceConsent": "Zgoda na korzystanie z usług NC",
    "careers": "Careers",
    "termsOfMobile": "모바일게임 약관",
  },
  footerWords: {
    "gameRelatedLaw": "Dodatkowe informacje o prawach dotyczących gier",
    "brandInformation": "Informacje o nazwie firmy",
    "copyright": "Prawa autorskie",
    "channelingInfo": "NC jest pośrednikiem zajmującym się sprzedażą wysyłkową gier w obrębie plaync, lecz nie jest stroną w tych transakcjach.<br>Wszelkie powinności i zobowiązania dotyczące tych gier spoczywają na poszczególnych stronach sprzedaży wysyłkowej, a NC nie ponosi odpowiedzialności za związane z nimi problemy.",
  },
  infoCS: {
    "businessInformation": "Sprawdź informacje o firmie",
    "infoAddress": "Nazwa firmy: NC Corporation, Co-CEO Kim Taek-Jin, Park Byung-Moo, numer rejestracyjny firmy: 220-81-43000, <br>E-commerce Registration: 2026-Seongnam Bundang A-0316",
    "infoAddressNCV": "9 RAFFLES PLACE #26-01 REPUBLIC PLAZA SINGAPORE (048619)",
    "mobile": "Adres: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republika Korei. <br>WSPARCIE klienta: +82 1600-0020. Fax: +82 02-2186-3550.",
    "pc": "Adres: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republika Korei. <br>WSPARCIE klienta: +82 1600-0020. Fax: +82 02-2186-3550.",
    "ncfamilyzone": "Adres: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republika Korei. <br>WSPARCIE klienta: +82 1600-0020. Fax: +82 02-2186-3550.",
    "other": "Adres: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republika Korei. <br>WSPARCIE klienta: +82 1600-0020. Fax: +82 02-2186-3550.",
    "none": "",
    "infoEmail": "Adres e-mail",
    "infoEmail-mobile": "MobileCS@ncsoft.com",
    "infoEmail-pc": "credit@ncsoft.com",
    "infoEmail-ncfamilyzone": "ncfamilyzone@ncsoft.com",
    "infoEmail-other": "credit@ncsoft.com/(gra na PC)/MobileCS@ncsoft.com/(gra mobilna)",
    "infoEmail-none": "",
  },
  infoJP: {
    "jpTitle": "Tytuł",
    "jpGenre": "Gatunek",
    "jpPrice": "Cena",
    "jpPriceValue": "Darmowa (zawiera zakupy w aplikacji)",
    "jpOs": "Wspierane systemy operacyjne",
    "jpPlatform": "Platforma",
    "jpDevelopedBy": "Producent/wydawca",
    "jpReleaseDay": "Data premiery",
    "jpReleaseDayValue_LW": "4 Listopada 2021 roku",
  },
  country: {
    "KR": "Republika Korei",
    "TW": "Tajwan",
    "RU": "Rosja",
    "MY": "Malezja",
    "SA": "Arabia Saudyjska",
    "SG": "Singapur",
    "AE": "Zjednoczone Emiraty Arabskie",
    "ID": "Indonezja",
    "JP": "Japonia",
    "QA": "Katar",
    "TH": "Tajlandia",
    "PH": "Filipiny",
    "HK": "Hong Kong",
    "UA": "Ukraina",
    "BY": "Białoruś",
    "LT": "Litwa",
    "PL": "Polska",
    "GR": "Grecja",
    "IL": "Izrael",
    "KW": "Kuwejt",
    "AT": "Austria",
    "US": "Stany Zjednoczone Ameryki",
    "CA": "Kanada",
    "DE": "Niemcy",
    "GB": "Zjednoczone Królestwo",
    "FR": "Francja",
    "BR": "Brazylia",
    "IT": "Włochy",
    "ES": "Hiszpania",
    "CL": "Chile",
    "NO": "Norwegia",
    "SE": "Szwecja",
    "IE": "Irlandia",
    "PT": "Portugalia",
    "FI": "Finlandia",
    "DK": "Dania",
    "CH": "Szwajcaria",
    "AR": "Argentyna",
    "PE": "Peru",
    "MX": "Meksyk",
    "KZ": "Kazachstan",
    "UZ": "Uzbekistan",
    "AZ": "Azerbejdżan",
    "GE": "Gruzja",
    "MD": "Mołdawia",
    "AM": "Armenia",
    "MO": "Makao",
    "IN": "Indie",
    "PK": "Pakistan",
    "NL": "Holandia",
    "RO": "Rumunia",
    "AU": "Australia",
    "TR": "Turcja",
    "EC": "Ekwador",
    "CO": "Kolumbia",
    "ZA": "Afryka Południowa",
    "EG": "Egipt",
    "NC": "Świat",
  },
};

export default l10n;
